export function PrevArrow(props) {
    const { className, onClick } = props;
    return (
      <button type="button" className={className} onClick={onClick}>
        <i className="fa fa-angle-right"></i>
      </button>
    );
  }